<template>
  <v-container class="fill-height pa-0 ">
    <v-row class="no-gutters elevation-4">
      <v-col cols="auto" class="flex-grow-1 flex-shrink-0">
        <v-responsive
          class="overflow-y-hidden fill-height"
          :height="isMessagingAllowed ? 600 : 500"
          width="400"
        >
          <v-card flat class="d-flex flex-column fill-height">
            <v-card dark style="background-color: rgb(43, 57, 144)">
              <v-card-title>
                <v-list-item-avatar color="grey darken-3">
                  <v-img
                    class="elevation-6"
                    alt=""
                    src="@/assets/logo-B.jpg/"
                  ></v-img>
                </v-list-item-avatar>
                <span class="text-overline title">ClimateRX - Chat</span>
              </v-card-title>
            </v-card>
            <v-card-text class="message-box" ref="scrollRef">
              <template v-for="(msg, i) in chatMessage">
                <div :class="{ 'd-flex flex-row-reverse': msg.me }" :key="i">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-list-item-avatar
                        color="grey darken-3"
                        :class="msg.me ? 'ml-3' : 'mr-3'"
                        v-if="!msg.me"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-img
                              class="elevation-6"
                              alt=""
                              :src="msg.User.Image"
                              v-bind="attrs"
                              v-on="on"
                            ></v-img>
                          </template>
                          <span>{{ msg.User.Name }}</span>
                        </v-tooltip>
                      </v-list-item-avatar>
                      <v-chip
                        :color="msg.me ? 'primary' : ''"
                        dark
                        style="height:auto;white-space: normal;"
                        class="pa-2 mb-2 message-content"
                        :class="!msg.me && chatMessageLikes(msg.Likes) > 0 ? 'relative r-24' : ''"
                        v-on="on"
                        width="50px"
                        @click="!msg.me ? likeMessage(msg._id, msg.Likes) : null"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span class="pa-2" v-bind="attrs" v-on="on">
                              {{ msg.Message }}
                            </span>
                          </template>
                          <span>{{ msg.createdAt }}</span>
                        </v-tooltip>
                      </v-chip>
                      <v-icon v-if="!msg.me && chatMessageLikes(msg.Likes) > 0" color="green" class="relative z-10 t-18">
                        mdi-thumb-up
                      </v-icon>
                      <v-icon v-else></v-icon>
                    </template>
                  </v-menu>
                </div>
              </template>
            </v-card-text>

            <v-card-text class="flex-shrink-1" v-if="isMessagingAllowed">
              <v-text-field
                v-model="message"
                label="Enter Message"
                type="text"
                no-details
                outlined
                append-outer-icon="send"
                @keyup.enter="sendMessage(message)"
                @click:append-outer="sendMessage(message)"
                hide-details
                clearable
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-responsive>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { format } from "timeago.js";
export default {
  props: {
    messages: {
      type: Array,
    },
  },

  data() {
    return {
      message: "",
      canMessage: 0,
    };
  },

  computed: {
    chatMessage() {
      let msg = this.messages.map((msg) => ({
        ...msg,
        createdAt: format(msg.createdAt),
      }));
      return msg;
    },

    isMessagingAllowed() {
      let allowedUserRoles = ['Administration', 'Program Coordinator'],
        canMessage = this.canMessage;

      if (localStorage.getItem('token') && allowedUserRoles.includes(localStorage.getItem('userRole'))) {
        canMessage = 1;
      }

      return canMessage;
    },
  },

  mounted() {
    this.scrollToEnd();
  },

  methods: {
    sendMessage(msg) {
      this.$emit("sendMessage", msg);
      this.message = "";
    },

    scrollToEnd() {
      this.$refs.scrollRef.scrollTop = this.$refs.scrollRef.scrollHeight;
    },

    likeMessage(chatMessageID, likes) { // Like message action
      let isChatMessageLiked = this.isChatMessageLiked(likes);

      this.$emit("likeMessage", chatMessageID, isChatMessageLiked);
    },

    isChatMessageLiked(likes) { // Identify if a specific chat message is already liked by the current user
      let userID = localStorage.getItem("userID");

      return likes.some((v) => {
        return v.userID === userID && v.isLike
      });
    },

    chatMessageLikes(likes) { // Count the number of likes for a specific chat message
      return likes.filter((v) => {
        return v.isLike;
      }).length;
    },
  },
};
</script>

<style scoped>
  .message-box {
    height: 100%;
    overflow-y: scroll;
    scroll-behavior: smooth;
  }

  .relative {
    position: relative;
  }

  .z-10 {
    z-index: 10;
  }

  .r-24 {
    right: 24px;
  }

  .t-18 {
    top: 18px;
  }
</style>
